import React, { useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { useDispatch, useSelector } from 'react-redux';

import { fetchNotifications } from '../../../redux/notifications/notificationActions';
import { updateSeenStatus } from '../../../services/notifications.service';
import FtuxComponent from '../FtuxComponent/FtuxComponent';
import SingleNotification from './SingleNotification';

import './_notificationsComponent.scss';

export default function NotificationsComponent({
  setSelectedInfluencer,
  setShowDemographics,
  setShowNotificationDropdown,
  setShowLitePlanModal = () => {},
  setDemographicsId,
  notificationIds,
  setNotificationIds,
}) {
  const { notifications, allNotificationsSeen, currentPage, totalPages, loading } = useSelector(
    (state) => state.notifications
  );
  const dispatch = useDispatch();

  const handleMarkAllAsRead = async () => {
    const response = await updateSeenStatus();
    if (response?.status) {
      NotificationManager.success('All notifications are now marked as read!', '', 1800);
      dispatch(fetchNotifications());
      setNotificationIds([]);
    } else {
      NotificationManager.error('Error while marking all notifications read', '', 1500);
    }
  };

  const handleViewMore = () => {
    if (loading || currentPage >= totalPages) return;
    dispatch(fetchNotifications(currentPage + 1, 'viewMore'));
  };

  return (
    <div className="notifications-main">
      <div className="notifications-header">
        <h2>Notifications</h2>
        {!allNotificationsSeen && <p onClick={handleMarkAllAsRead}>Mark all as read</p>}
      </div>
      <div className="notifications-container">
        {notifications?.length === 0 ? (
          <FtuxComponent
            icon="🔔"
            iconBgColor={'#F6F6F6'}
            titleStyle={{ fontSize: '18px' }}
            textStyle={{ maxWidth: '280px', color: 'var(--text-default)' }}
            title="No notifications yet"
            text="Your notifications will show up here. Stay tuned!"
          />
        ) : (
          notifications?.map((notification, idx) => (
            <SingleNotification
              key={idx}
              notification={notification}
              setShowDemographics={setShowDemographics}
              setSelectedInfluencer={setSelectedInfluencer}
              setShowNotificationDropdown={setShowNotificationDropdown}
              setShowLitePlanModal={setShowLitePlanModal}
              setDemographicsId={setDemographicsId}
              setNotificationIds={setNotificationIds}
              notificationIds={notificationIds}
            />
          ))
        )}
        {currentPage < totalPages && (
          <div className="view-more" onClick={handleViewMore}>
            view more
          </div>
        )}
      </div>
    </div>
  );
}
